import React__default from 'react';
import PropTypes from 'prop-types';

var propTypes = {
  children: PropTypes.node.isRequired,
  firstButton: PropTypes.shape({
    labelText: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    isDisabled: PropTypes.bool
  }),
  lastButton: PropTypes.shape({
    labelText: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    isDisabled: PropTypes.bool
  }),
  nextButton: PropTypes.shape({
    labelText: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    isDisabled: PropTypes.bool
  }),
  previousButton: PropTypes.shape({
    labelText: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    isDisabled: PropTypes.bool
  }),
  variant: PropTypes.oneOf(['default', 'abbreviated'])
};
function Pagination(_ref) {
  var children = _ref.children,
    firstButton = _ref.firstButton,
    lastButton = _ref.lastButton,
    nextButton = _ref.nextButton,
    previousButton = _ref.previousButton,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'default' : _ref$variant;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "pagination-jsx",
    "data-testid": "pagination",
    "data-variant": variant
  }, firstButton ? /*#__PURE__*/React__default.createElement("button", {
    "aria-label": firstButton.labelText,
    className: "pagination-first-button",
    disabled: firstButton.isDisabled,
    onClick: firstButton.onClick,
    type: "button"
  }) : null, previousButton ? /*#__PURE__*/React__default.createElement("button", {
    "aria-label": previousButton.labelText,
    className: "pagination-previous-button",
    disabled: previousButton.isDisabled,
    onClick: previousButton.onClick,
    type: "button"
  }) : null, /*#__PURE__*/React__default.createElement("div", {
    className: "page-indicator"
  }, children), nextButton ? /*#__PURE__*/React__default.createElement("button", {
    "aria-label": nextButton.labelText,
    className: "pagination-next-button",
    disabled: nextButton.isDisabled,
    onClick: nextButton.onClick,
    type: "button"
  }) : null, lastButton ? /*#__PURE__*/React__default.createElement("button", {
    "aria-label": lastButton.labelText,
    className: "pagination-last-button",
    disabled: lastButton.isDisabled,
    onClick: lastButton.onClick,
    type: "button"
  }) : null);
}
Pagination.propTypes = propTypes;

export { Pagination as default };
//# sourceMappingURL=Pagination.js.map
